import React from 'react';
import { SunIcon, MoonIcon, ZapIcon } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-20 bg-[#0a0f1e]" data-id="element-98">
      <div className="max-w-4xl mx-auto px-4 sm:px-6" data-id="element-99">
        <div className="text-center mb-16" data-id="element-100">
          <span className="text-[#00d4ff] font-semibold tracking-widest uppercase text-sm" data-id="element-101">
            La Solución Científica
          </span>
          <h2 className="font-heading text-4xl md:text-6xl font-bold text-white mt-2 mb-6 uppercase" data-id="element-102">
            El "Bio-Clock Reset"
          </h2>
          <p className="text-xl text-slate-300 max-w-2xl mx-auto" data-id="element-103">
            Tu cuerpo tiene un reloj maestro. Si lo sincronizas, la quema de
            grasa se vuelve automática.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mb-16" data-id="element-104">
          <div className="bg-[#0d1529] p-6 rounded-2xl border border-slate-700/50 hover:border-[#00d4ff]/40 transition-colors" data-id="element-105">
            <div className="w-12 h-12 bg-yellow-500/10 rounded-full flex items-center justify-center mb-4 border border-yellow-500/30" data-id="element-106">
              <SunIcon className="w-6 h-6 text-yellow-400" data-id="element-107" />
            </div>
            <h3 className="font-heading text-xl font-bold text-white mb-2 uppercase" data-id="element-108">
              Luz Matutina
            </h3>
            <p className="text-slate-400" data-id="element-109">
              El secreto para apagar la melatonina y encender tu motor
              metabólico desde la primera hora del día.
            </p>
          </div>

          <div className="bg-[#0d1529] p-6 rounded-2xl border border-slate-700/50 hover:border-[#00d4ff]/40 transition-colors" data-id="element-110">
            <div className="w-12 h-12 bg-[#00d4ff]/10 rounded-full flex items-center justify-center mb-4 border border-[#00d4ff]/30" data-id="element-111">
              <ZapIcon className="w-6 h-6 text-[#00d4ff]" data-id="element-112" />
            </div>
            <h3 className="font-heading text-xl font-bold text-white mb-2 uppercase" data-id="element-113">
              Ventana de Alimentación
            </h3>
            <p className="text-slate-400" data-id="element-114">
              No es dejar de comer. Es comer cuando tu cuerpo está listo para
              procesar energía, no para almacenarla.
            </p>
          </div>

          <div className="bg-[#0d1529] p-6 rounded-2xl border border-slate-700/50 hover:border-[#00d4ff]/40 transition-colors" data-id="element-115">
            <div className="w-12 h-12 bg-indigo-500/10 rounded-full flex items-center justify-center mb-4 border border-indigo-500/30" data-id="element-116">
              <MoonIcon className="w-6 h-6 text-indigo-400" data-id="element-117" />
            </div>
            <h3 className="font-heading text-xl font-bold text-white mb-2 uppercase" data-id="element-118">
              Descanso Profundo
            </h3>
            <p className="text-slate-400" data-id="element-119">
              Optimizamos tu sueño para que la hormona del crecimiento repare
              tejidos y queme grasa mientras duermes.
            </p>
          </div>
        </div>

        {/* Result callout */}
        <div className="bg-gradient-to-br from-[#0d1529] to-[#0a1a2e] text-white p-8 md:p-12 rounded-3xl relative overflow-hidden border border-[#00d4ff]/20" data-id="element-120">
          <div className="absolute top-0 right-0 -mt-10 -mr-10 w-60 h-60 bg-[#00d4ff] rounded-full blur-3xl opacity-10" data-id="element-121"></div>
          <div className="relative z-10" data-id="element-122">
            <h3 className="font-heading text-3xl font-bold mb-4 uppercase" data-id="element-123">
              El Resultado: Cuerpo 4.0
            </h3>
            <p className="text-lg text-slate-300 mb-6" data-id="element-124">
              Cuando alineas tu ritmo circadiano, la inflamación baja, la
              energía sube y la grasa abdominal empieza a usarse como
              combustible. Sin pastillas mágicas, solo biología pura.
            </p>
            <ul className="space-y-3" data-id="element-125">
              {['Energía estable todo el día', 'Claridad mental y enfoque', 'Reducción visible de la cintura'].map(item => <li key={item} className="flex items-center" data-id="element-126">
                  <div className="w-2 h-2 bg-[#00d4ff] rounded-full mr-3 shrink-0" data-id="element-127"></div>
                  <span className="text-slate-200" data-id="element-128">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}